import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const BUSINESS_EMAIL = 'aloudillon@tdbtraining.com';
const BUSINESS_PHONE = '+1 (414) 786-6593';
const BUSINESS_PHONE_HREF = 'tel:+14147866593';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToId = (id) => {
    if (location.pathname === '/') {
      navigate('/basketball', { state: { scrollTo: id } });
      return;
    }
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/basketball', { state: { scrollTo: id } });
    }
  };

  const goApplicationForm = () => scrollToId('train-with-me');

  return (
    <footer className="bg-neutral-950 border-t border-neutral-800 py-12" data-testid="site-footer">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12 mb-10">
          {/* Brand */}
          <div className="space-y-4">
            <div className="text-xl sm:text-2xl font-black uppercase leading-tight">
              <span className="text-white">The Dillon</span>{' '}
              <span className="text-gray-400">Blueprint</span>
            </div>
            <p className="text-gray-400 text-sm max-w-xs leading-relaxed">
              Two paths. One goal: becoming the strongest version of yourself.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-white font-bold text-lg">Quick Links</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <Link to="/basketball" className="hover:text-gray-200 transition-colors">Basketball</Link>
              </li>
              <li>
                <Link to="/fitness" className="hover:text-gray-200 transition-colors">Fitness</Link>
              </li>
              <li>
                <button
                  data-testid="footer-results"
                  onClick={() => scrollToId('player-results')}
                  className="hover:text-gray-200 transition-colors"
                >
                  Results
                </button>
              </li>
              <li>
                <button
                  data-testid="footer-about"
                  onClick={() => scrollToId('about-dillon')}
                  className="hover:text-gray-200 transition-colors"
                >
                  About
                </button>
              </li>
            </ul>
          </div>

          {/* Get Started */}
          <div className="space-y-4">
            <h3 className="text-white font-bold text-lg">Get Started</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <button
                  data-testid="footer-train-with-me"
                  onClick={goApplicationForm}
                  className="hover:text-gray-200 transition-colors"
                >
                  Train With Me
                </button>
              </li>
              <li>
                <button
                  data-testid="footer-book-session"
                  onClick={goApplicationForm}
                  className="hover:text-gray-200 transition-colors"
                >
                  Book A Session
                </button>
              </li>
              <li>
                <a
                  href="https://instagram.com/thedillonblueprint"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-gray-200 transition-colors"
                >
                  @thedillonblueprint
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-4" data-testid="footer-contact-block">
            <h3 className="text-white font-bold text-lg">Contact</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <a href={`mailto:${BUSINESS_EMAIL}`} className="hover:text-gray-200 transition-colors">
                  {BUSINESS_EMAIL}
                </a>
              </li>
              <li>
                <a href={BUSINESS_PHONE_HREF} className="hover:text-gray-200 transition-colors">
                  {BUSINESS_PHONE}
                </a>
              </li>
              <li>Milwaukee, Wisconsin</li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-neutral-800 pt-6">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
            <p className="text-gray-500 text-sm">© {currentYear} The Dillon Blueprint</p>
            <div className="flex gap-6 text-sm">
              <Link
                to="/privacy-policy"
                data-testid="footer-privacy"
                className="text-gray-400 hover:text-white transition-colors underline underline-offset-4"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms-and-conditions"
                data-testid="footer-terms"
                className="text-gray-400 hover:text-white transition-colors underline underline-offset-4"
              >
                Terms &amp; Conditions
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
